"use strict";
exports.__esModule = true;
exports.QuoteHelper = void 0;
var model_1 = require("../../rate/model");
var getDefaultCancelConditionName = function (quote) {
    var cancelCondition = quote.cancelConditions.name.find(function (name) { return name.value === model_1.CancelConditionType.Default; });
    return cancelCondition && cancelCondition.text;
};
var getDefaultCancelConditionMessage = function (quote) {
    var cancelCondition = quote.cancelConditions.summary.find(function (summary) { return summary.value === model_1.CancelConditionType.Default; });
    return cancelCondition && cancelCondition.text;
};
var initObjectForCreateBody = function () {
    return {
        customerDetails: { firstName: undefined, lastName: undefined, countryCode: undefined, emailAddress: undefined }
    };
};
exports.QuoteHelper = { getDefaultCancelConditionName: getDefaultCancelConditionName, getDefaultCancelConditionMessage: getDefaultCancelConditionMessage, initObjectForCreateBody: initObjectForCreateBody };
//# sourceMappingURL=quote.helper.js.map